import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { HashLink } from 'react-router-hash-link'

import { ILocationParams } from '../../common/reducers/reactRouterLocation'

export interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  currentSite?: Site
  hash?: string
}

const SearchLink = ({
  locationParams,
  makeSearchLink,
  currentSite,
  hash,
  children,
  ...props
}: IProps) => {
  const hashString = hash ? `#${hash}` : ''
  const linkTo = `${makeSearchLink(locationParams, currentSite)}${hashString}`
  return (
    <HashLink to={linkTo} {...props}>
      {children}
    </HashLink>
  )
}

export default SearchLink
